<template>
  <div v-show="!isLoading">
    <md-table v-model="payments" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell md-label="Vencimento">{{
          item.date || formatDate(item.dueAt)
        }}</md-table-cell>
        <md-table-cell md-label="Preço">{{
          typeof item.price === "string"
            ? `R$ ${item.price}`
            : formatMoney(item.price)
        }}</md-table-cell>
        <md-table-cell md-label="Código">{{
          item.code || item.id
        }}</md-table-cell>
        <md-table-cell md-label="Ações">
          <div v-if="item.link">
            <a
              @click="copy(item.code)"
              href="#"
              title="Copiar código do boleto"
            >
              <md-icon>content_copy</md-icon>
            </a>
            <a
              :href="
                `https://api.globalfibra.com.br/app/download?link=${item.link}`
              "
              target="_blank"
              title="Abrir"
            >
              <md-icon>receipt_long</md-icon>
            </a>
          </div>
          <span v-else> - </span>
        </md-table-cell>
        <md-table-cell md-label="Status">
          <span
            :class="{
              badge: true,
              'badge-red': item.status === 'Pagamento Atrasado',
              'badge-yellow': item.status === 'Pagamento Pendente',
              'badge-green': item.status === 'Pago'
            }"
            >{{ item.status }}</span
          >
        </md-table-cell>
      </md-table-row>
    </md-table>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import { format, parseISO } from "date-fns";
import { formatMoney } from "@/helpers";

export default {
  name: "payment-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    pendingPayments() {
      return this.$store.getters.pendingPayments;
    },
    paidPayments() {
      return this.$store.getters.paidPayments;
    }
  },
  data() {
    return {
      isLoading: false,
      payments: [],
      type: ["", "info", "success", "warning", "danger"],
      notifications: {
        topCenter: false
      }
    };
  },
  methods: {
    ...mapActions(["fetchPendingPayments", "fetchPaidPayments"]),
    formatMoney,
    formatDate(value) {
      const date = new Date(value);
      date.setDate(date.getDate() + 1);
      return format(date, "dd/MM/yyyy");
    },
    isDueMonth(date) {
      const today = new Date();

      const dates = date.split("/");
      const dueDate = new Date(`${dates[1]}/${dates[0]}/${dates[2]}`);

      return (
        today.getFullYear() >= dueDate.getFullYear() &&
        ((today.getDate() > dueDate.getDate() &&
          today.getMonth() == dueDate.getMonth()) ||
          today.getMonth() > dueDate.getMonth())
      );
    },
    notifyVue(message) {
      this.$notify({
        message,
        icon: "check_circle",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: "success"
      });
    },
    async copy(code) {
      await navigator.clipboard.writeText(code);
      this.notifyVue("Código copiado");
    }
  },
  async mounted() {
    const isPossibleFirstLoad = this.pendingPayments.length === 0;

    let loader = null;
    if (isPossibleFirstLoad) {
      this.isLoading = true;

      loader = this.$loading.show({
        color: "#A9CD84",
        lockScroll: true,
        container: this.$refs.formContainer,
        canCancel: false
      });
    }

    this.pendingPayments.forEach(payment => {
      if (this.isDueMonth(payment.date)) {
        payment.status = "Pagamento Atrasado";
      } else {
        payment.status = "Pagamento Pendente";
      }
    });

    this.paidPayments.forEach(payment => {
      payment.status = "Pago";
    });

    this.payments = [...this.pendingPayments, ...this.paidPayments];

    try {
      await Promise.all([
        this.fetchPaidPayments({ id: this.user.id }),
        this.fetchPendingPayments({ taxId: this.user.taxId })
      ]);
    } catch (e) {
      Swal.fire("Ops!", "Não foi possível obter os dados.", "error");
    }

    this.pendingPayments.forEach(payment => {
      if (this.isDueMonth(payment.date)) {
        payment.status = "Pagamento Atrasado";
      } else {
        payment.status = "Pagamento Pendente";
      }
    });

    this.paidPayments.forEach(payment => {
      payment.status = "Pago";
    });

    this.payments = [...this.pendingPayments, ...this.paidPayments];

    if (loader) {
      this.isLoading = false;
      loader.hide();
    }
  }
};
</script>
